import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  containerStyle,
  innerContainerStyle,
  tabStyle,
  activeTabStyle,
  inactiveTabStyle
} from './styles';

interface TabBarProps {
  activeTabIndex: number;
  setActiveTabIndex: (index: number) => void;
}

const TabBar: FC<TabBarProps> = ({ activeTabIndex, setActiveTabIndex }) => {
  const { t } = useTranslation();

  return (
    <div style={containerStyle}>
      <div style={innerContainerStyle}>
        <div
          style={{
            ...tabStyle,
            ...(activeTabIndex === 0 ? activeTabStyle : inactiveTabStyle)
          }}
          onClick={() => setActiveTabIndex(0)}
        >
          {t('earn.challenges')}
        </div>
        <div
          style={{
            ...tabStyle,
            ...(activeTabIndex === 1 ? activeTabStyle : inactiveTabStyle)
          }}
          onClick={() => setActiveTabIndex(1)}
        >
          {t('earn.history')}
        </div>
      </div>
    </div>
  );
};

export default TabBar;
